import React, { Component } from "react";
import styles from "./appointments.module.css";
import basestyles from "../../../shared/styles/basestyles.module.css";
import Header from "../../../shared/components/Header/Header";
import Backicon from "../../../shared/components/Backicon/Backicon";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

class Appointments extends Component {
  state = {
    patientAppointmentOverview: "",
  };

  componentDidMount() {
    let appointments = JSON.parse(localStorage.getItem("patient_appointment"));
    this.setState({
      patientAppointmentOverview: appointments ? appointments.data : [],
    });
  }

  handleRemove = (id) => {
    let filteredAppointments = this.state.patientAppointmentOverview.filter(
      (appointment) => appointment.id !== id
    );
    console.log(this.state.patientAppointmentOverview);
    this.setState({ patientAppointmentOverview: filteredAppointments }, () => {
      localStorage.setItem(
        "patient_appointment",
        JSON.stringify({ data: this.state.patientAppointmentOverview })
      );
    });
  };

  scheduleAppoitment = () => {
    toast.info("Appointment scheduled...!", {
      autoClose: 2000,
    });
  };

  render() {
    return (
      <>
        <div className={styles.backgroundappoint}>
          <Header name="All Appointments" />
          <Backicon
            onClick={() => this.props.history.goBack()}
            style={{
              background:
                "linear-gradient(60deg, rgba(2, 12, 29, 0.644) 0%, rgba(67, 184, 192, 0.548) 98%)",
              color: "white",
            }}
          />
          <div className={basestyles.inputWidth}>
            <div className={styles.allapt}>
              <table>
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Name</th>
                    <th>Problem</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.patientAppointmentOverview &&
                    this.state.patientAppointmentOverview.map((appointment) => (
                      <tr key={appointment.id}>
                        <td>{appointment.id}</td>
                        <td>{appointment.Name}</td>
                        <td>{appointment.TypeOfProblemHeSheIsFacing}</td>
                        <td className={styles.acceptTrash}>
                          <i
                            className={"far fa-check-square"}
                            onClick={() => this.scheduleAppoitment()}
                          >
                            <ToastContainer />
                          </i>
                          <i
                            className={"fas fa-trash"}
                            onClick={() => this.handleRemove(appointment.id)}
                          ></i>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default Appointments;
